import { ResizeBox } from "@/components/shared/resize-box";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { PencilIcon, Trash2Icon } from "lucide-react";
import { ReactTableCell } from "../react-table-cell/react-table-cell";
import { ReactTableHeader } from "@/components/shared/react-table-header";
import { GenericType } from "@/types";
import { useUserInfo } from "@/global-data/use-user-info";
export const ReactTable = ({
  tableHeader,
  onResize,
  table,
  onAction,
  filter,
  setFilter,
  listData,
  filterRequest,
}: GenericType) => {
  const { activePermission } = useUserInfo();
  return (
    <Table style={{ borderCollapse: "collapse" }}>
      <TableHeader>
        <TableRow>
          <TableHead className="hidden">
            <input type="checkbox" />
          </TableHead>
          {tableHeader?.map((header: GenericType, index: number) => (
            <TableHead
              key={header.accessorKey}
              style={{
                width: header.width,
                minWidth: header.minWidth,
                maxWidth: header.maxWidth,
              }}
              className={cn({ "pl-5": index === 0 })}
            >
              <ResizeBox
                width={header.width}
                onResize={(props: GenericType) =>
                  onResize({ size: props, key: header.accessorKey })
                }
              >
                <ReactTableHeader
                  label={header.header}
                  key={header.accessorKey}
                  header={header.accessorKey}
                  table={listData}
                  setFilter={setFilter}
                  filter={filter}
                  filterRequest={filterRequest}
                >
                  {header.header}
                </ReactTableHeader>
              </ResizeBox>
            </TableHead>
          ))}
          <TableHead className="text-center w-auto sticky right-0 z-[2] pr-0">
            <div className="flex justify-end ">
              <div className="w-[135px] text-left pl-[8px]">Actions</div>
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {table.map((row: GenericType, rowIndex: number) => (
          <TableRow key={row.id + rowIndex}>
            <TableCell className="w-[30px] hidden">
              <input type="checkbox" />
            </TableCell>
            {row.data.map((cell: GenericType, index: number) => (
              <TableCell
                key={cell.key + index}
                width={cell.width}
                style={{ width: cell.width }}
                className={cn({ "pl-3": index === 0 })}
              >
                <ReactTableCell header={cell.key} value={cell.value} />
              </TableCell>
            ))}
            <TableCell
              className="text-right sticky right-0 w-auto bg-white"
              nestedClassName="pr-0"
            >
              <div className="flex items-center justify-end z-[2] bg-white">
                <div className="flex items-center w-[135px]">
                  <TooltipProvider>
                    {activePermission?.update ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({ data: row.originData, action: "edit" })
                            }
                          >
                            <PencilIcon />
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>Edit</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}

                    {activePermission?.delete ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({
                                data: row.originData,
                                action: "delete",
                              })
                            }
                          >
                            <Trash2Icon />
                          </Button>
                        </TooltipTrigger>

                        <TooltipContent>
                          <p>Delete</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}
                  </TooltipProvider>
                </div>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
